/**
 * Customized letter spacing.
 *
 * Reference: https://chakra-ui.com/docs/theming/customize-theme
 * Figma: https://www.figma.com/file/r6UgR31y46olhktfYk0EZA/Design-Systems-In-Progress?node-id=8%3A49
 */

const textStyles = {
  /* Header Display Styles */
  displayXxl: {
    fontWeight: '500',
    fontSize: '72px', // 8xl
    letterSpacing: '-0.02em',
    lineHeight: '88px'
  },
  displayXxl600: {
    fontWeight: '600',
    fontSize: '72px',
    letterSpacing: '-0.02em',
    lineHeight: '88px'
  },
  displayXl: {
    fontWeight: '500',
    fontSize: '72px', // 7xl
    letterSpacing: '-0.02em',
    lineHeight: '80px'
  },
  displayXl600: {
    fontWeight: '600',
    fontSize: '64px',
    letterSpacing: '-0.02em',
    lineHeight: '80px'
  },
  displayLg: {
    fontWeight: '500',
    fontSize: '56px', // 6xl
    letterSpacing: '-0.02em',
    lineHeight: '72px'
  },
  displayLg600: {
    fontWeight: '500',
    fontSize: '56px',
    letterSpacing: '-0.02em',
    lineHeight: '72px'
  },
  displayMd: {
    fontWeight: '500',
    fontSize: '48px', // 5xl
    letterSpacing: '-0.02em',
    lineHeight: '64px'
  },
  displayMd600: {
    fontWeight: '600',
    fontSize: '48px',
    letterSpacing: '-0.02em',
    lineHeight: '64px'
  },
  displaySm: {
    fontWeight: '500',
    fontSize: '40px', // 4xl
    letterSpacing: '-0.02em',
    lineHeight: '56px'
  },
  displaySm600: {
    fontWeight: '600',
    fontSize: '40px',
    letterSpacing: '-0.02em',
    lineHeight: '56px'
  },
  displayXs: {
    fontWeight: '500',
    fontSize: '32px', // 3xl
    letterSpacing: '-0.02em',
    lineHeight: '40px'
  },
  displayXs600: {
    fontWeight: '600',
    fontSize: '32px',
    letterSpacing: '-0.02em',
    lineHeight: '40px'
  },
  displayXxs: {
    fontWeight: '500',
    fontSize: '24px', // xxl
    letterSpacing: '-0.02em',
    lineHeight: '32px'
  },
  displayXxs600: {
    fontWeight: '600',
    fontSize: '24px',
    letterSpacing: '-0.02em',
    lineHeight: '32px'
  },
  /* Body Styles */
  bodyXxl: {
    fontWeight: '400',
    fontSize: '20px', // xl
    letterSpacing: '-0.02em',
    lineHeight: '30px'
  },
  bodyXxl500: {
    fontWeight: '500',
    fontSize: '20px',
    letterSpacing: '-0.02em',
    lineHeight: '30px'
  },
  bodyXxl600: {
    fontWeight: '600',
    fontSize: '20px',
    letterSpacing: '-0.02em',
    lineHeight: '30px'
  },
  bodyXl: {
    fontWeight: '400',
    fontSize: '18px', // lg
    letterSpacing: '-0.02em',
    lineHeight: '28px'
  },
  bodyXl500: {
    fontWeight: '500',
    fontSize: '18px',
    letterSpacing: '-0.02em',
    lineHeight: '28px'
  },
  bodyXl600: {
    fontWeight: '600',
    fontSize: '18px',
    letterSpacing: '-0.02em',
    lineHeight: '28px'
  },
  /* Default body style */
  bodyLg: {
    fontWeight: '400',
    fontSize: '16px', // md
    letterSpacing: '-0.02em',
    lineHeight: '24px'
  },
  bodyLg500: {
    fontWeight: '500',
    fontSize: '16px',
    letterSpacing: '-0.02em',
    lineHeight: '24px'
  },
  bodyLg600: {
    fontWeight: '600',
    fontSize: '16px',
    letterSpacing: '-0.02em',
    lineHeight: '24px'
  },
  bodyMd: {
    fontWeight: '400',
    fontSize: '15px', // sm
    letterSpacing: '-0.02em',
    lineHeight: '20px'
  },
  bodyMd500: {
    fontWeight: '500',
    fontSize: '15px',
    letterSpacing: '-0.02em',
    lineHeight: '20px'
  },
  bodyMd600: {
    fontWeight: '600',
    fontSize: '15px',
    letterSpacing: '-0.02em',
    lineHeight: '20px'
  },
  bodySm: {
    fontWeight: '400',
    fontSize: '13px', // xs
    letterSpacing: '-0.02em',
    lineHeight: '18px'
  },
  bodySm500: {
    fontWeight: '500',
    fontSize: '13px',
    letterSpacing: '-0.02em',
    lineHeight: '18px'
  },
  bodySm600: {
    fontWeight: '600',
    fontSize: '13px',
    letterSpacing: '-0.02em',
    lineHeight: '18px'
  },
  bodyXs: {
    fontWeight: '400',
    fontSize: '11px', // xxs
    letterSpacing: '-0.02em',
    lineHeight: '16px'
  },
  bodyXs500: {
    fontWeight: '500',
    fontSize: '11px',
    letterSpacing: '-0.02em',
    lineHeight: '16px'
  },
  bodyXs600: {
    fontWeight: '600',
    fontSize: '11px',
    letterSpacing: '-0.02em',
    lineHeight: '16px'
  },
  /* Buttons */
  button: {
    fontWeight: '500',
    fontSize: '15px',
    lineHeight: '24px',
    textTransform: 'capitalize',
    letterSpacing: '-0.02em'
  }
};

export default textStyles;
